export const APP_ROOT_ID = 'custom-bottle-root';
export const CUSTOM_OPSIONS_PARAM_KEY = 'options';
